'use strict';
import { toast } from '@arritech/ui/Toast';
import { useAuthStore } from '@/stores/auth';
import { pinia } from '@/stores/pinia';

const RELOAD_DELAY_MS = 60000;

export const updateValueAndShowModal = (version) => {
	toast({
		title: 'QGenOnline update',
		message:
			'QgenOnline application has been successfully updated to version ' +
			version +
			'. Application will reload in 1 minute.',
		type: 'success',
		dismissible: true,
		duration: 30000,
	});
	setTimeout(() => {
		window.location.reload();
	}, RELOAD_DELAY_MS);
};

export const hasValueChanged = (value) => {
	const authStore = useAuthStore(pinia);
	return value !== authStore.getVersion;
};
